import {
    IDetailField,
} from '../types';

import {
    PAYMENT_PAGE_TYPE,
    UPI_P2P_KEY,
} from 'entities/payment-methods/constants';

export function filterDetailFields(paymentPageType: PAYMENT_PAGE_TYPE, detailFields: IDetailField[]): IDetailField[] {
    switch (paymentPageType) {
        case PAYMENT_PAGE_TYPE.DEFAULT:
        case PAYMENT_PAGE_TYPE.UPI_INTENT_QR: {
            return detailFields;
        }
        case PAYMENT_PAGE_TYPE.UPI_P2P: {
            return detailFields.filter((detailField) => detailField.key !== UPI_P2P_KEY.ACCOUNT_NAME);
        }
    }
}
